<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Has your high sensitivity C-reactive protein (hsCRP) been checked? <br />
      If yes, what was your highest score?
    </h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.wasChecked">
      <b-form-radio v-model="survey.medicalConditions.cReactiveProtein.wasChecked" name="hscrp"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.medicalConditions.cReactiveProtein.wasChecked" name="hscrp"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
    <v-form-group v-if="wasChecked" class="page-buttons" :validator="$v.highestScore" label="Highest score">
      <b-form-input slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="survey.medicalConditions.cReactiveProtein.highestScore"
                    placeholder="Highest score" />
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between, requiredIf, decimal } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      wasChecked: {
        required
      },
      highestScore: {
        required: requiredIf(function () { return this.wasChecked; }),
        decimal,
        between: between(0, 250)
      }
    },

    computed: {
      ...mapState(["survey"]),

      wasChecked() { return this.survey.medicalConditions.cReactiveProtein.wasChecked; },
      highestScore() { return this.survey.medicalConditions.cReactiveProtein.highestScore; }
    }
  };
</script>